<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.fan.menu"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.fan.list.title"></app-i18n>
      </h1>

      <app-fan-list-toolbar></app-fan-list-toolbar>
      <app-fan-list-filter></app-fan-list-filter>
      <app-fan-list-table></app-fan-list-table>
    </div>
  </div>
</template>

<script>
import FanListFilter from '@modules/fan/components/fan-list-filter.vue';
import FanListTable from '@modules/fan/components/fan-list-table.vue';
import FanListToolbar from '@modules/fan/components/fan-list-toolbar.vue';

export default {
  name: 'app-fan-list-page',

  components: {
    [FanListFilter.name]: FanListFilter,
    [FanListTable.name]: FanListTable,
    [FanListToolbar.name]: FanListToolbar,
  },
};
</script>

<style>
</style>
